import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import UserAvatar from "./UserAvatar";
import { useMessageContext } from "provider/MessageProvider";
import { useScreenSize } from "provider/ScreenSizeProvider";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { handleError } from "components/Api/handleError";
import { useAuth } from "provider/AuthContext";
import apiCall from "components/Api/api";
import { useToast } from "provider/ToastProvider";

const ActiveUser = ({ user }) => {
    const { isMobileView } = useScreenSize();
    const navigate = useNavigate();
    const { logout } = useAuth();
    const { showSuccessToast } = useToast();
    const {  activeTab, activeUser, messageDispatch } = useMessageContext();
    const [loading, setLoading] = useState(false);
    const [ , setError] = useState("");

    const makePhoneCall = async (activeUser) => {
        if (activeUser.can_call !== true) return

        try {
            setLoading(true);
            const URL = `chat/make-call-on-chat/${activeUser?.contact?.user_handle}?chat_hash=${activeUser?.chat_hash}`;
            // Post Comment
            const response = await apiCall({
                url: URL,
                method: "POST",
            });
            if (response.status !== 200) {
                throw new Error(`Unexpected status code: ${response.status}`);
            }
            const apiData = response.data;
            //check error after 200/ok
            if (response.status === 200 || response.status === 201) {
                if (apiData?.errors) {
                    const errors = apiData.errors;

                    Object.keys(errors).forEach((key) => {
                        const errorMessages = errors[key];
                        const firstErrorMessage = errorMessages[0]; // Take only the first error
                        setError((prevData) => ({
                            ...prevData,
                            [key]: firstErrorMessage,
                        }));
                    });
                    return; // Stop further execution if there are errors
                }
                //update last message in left bar
                if (apiData?.status === 1) {
                    showSuccessToast(apiData?.message);
                }



            } else {
                setError("Failed to post comment. Please try again.");
            }
        } catch (error) {
            setError("An error occurred. Please try again.");
            handleError(error, logout, navigate);
        } finally {
            setLoading(false);
        }

    }

    return (
        <div className="d-flex chat-message-header pb-4 justify-content-between border-bottom">
            <div className="chat-profile d-flex align-items-center gap-3">
                {isMobileView && <div className="icons-show back-btn"
                    onClick={() => {
                        messageDispatch({ type: `TOGGLE_CHAT_CONTACT`, payload: false });
                    }}
                >
                    <i className="fa-solid fa-chevron-left"></i>
                </div>
                }
                <Link to="#" style={{ color: "inherit" }} className="d-flex align-items-center gap-2">
                    <UserAvatar src={user?.profile_display_image} alt={user?.display_name} size={45} />
                    <span className="fw-medium">{user?.display_name || "Unnamed User"}</span>
                </Link>


            </div>
            {/* {activeTab === 'quote-requests' && <div>
                <Button
                    type="submit"
                    className="chat-quotation-btn rounded-2 w-100"
                    onClick={handleOpen}
                >
                    Share Itinerary & Quotation
                </Button>
            </div>
            } */}
            {(activeTab === 'quote-requests' && activeUser?.can_call) && <button
                onClick={() => { makePhoneCall(activeUser) }}
                className="bg-transparent"
                style={{
                    border: "none",
                    color: "#000",
                    fontSize: "26px",
                    fontWeight: "900",
                    cursor: "pointer"
                }}
                disabled={loading}
            >
                <FontAwesomeIcon icon={faPhone} size="sm" />
            </button>
            }
        </div>
    );
};

export default ActiveUser;
